import { autoinject, transient } from "aurelia-framework";
import * as moment from "moment";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { BaseHistoryTrail } from "../../../common/base-history-trail";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
export class VettingCriteriaHistoryTrail extends BaseHistoryTrail<{ id: number, entityType: number }> {

    public audits: any[] = [];
    public id: number;
    public entityTypeId: number;
    public loading: boolean = true;


    constructor(private queriesClientService: QueriesClientService, private dialogClientService: DialogClientService, 
        notificationClientService: NotificationClientService, i18N: I18N, protected configService: ConfigService) {
        super(configService, notificationClientService, i18N);
    }


    onActivated() {
        this.id = this.item.id;
        this.entityTypeId = this.item.entityType ? this.item.entityType : <number>EntityTypes.Vessel;
        this.refreshData();
    }

    public refreshData() {
        this.loading = true;
        this.queriesClientService.getData(`/odata/RightShipAudits/Genesis.GetAudits(entityTypeId=${this.entityTypeId},entityId=${this.id})?$orderby=timestamp desc`).then(x => {
            this.audits = x.value;
            setTimeout(() => {
                this.loading = false;
            });
        })
            .catch(e => {
                this.loading = false;
                console.error(e);
            });
    }

    getFormattedDate(date) {
        return moment(date).format('DD MMM YYYY HH:mm');
    }

    close() {
        this.dialogClientService.hide();
    }
}